import { post, get } from "@shared/core/io";
import { wrapGatewaySuperagent, afterGateway, SOURCE_TYPE } from "@shared/apis/gw-helper";
import { getRiskParams } from "@shared/apis/risk-helper";

const CORDER_V1_API_PREFIX = "/gw/corder/api/v1";

export function cancelOrder(data) {
  return post(`${CORDER_V1_API_PREFIX}/order/cancel`, data);
}

export function pricePreview(data) {
  return wrapGatewaySuperagent(
    post(`${CORDER_V1_API_PREFIX}/search/pricePreview`, {
      currentTimeMillis: new Date().getTime(),
      sourceType: SOURCE_TYPE,
      ...data,
      deviceInfoByWeb: {
        ...getRiskParams(),
        ...(data || {}).deviceInfoByWeb,
      },
    })
  );
}

export function submitOrder(data) {
  return wrapGatewaySuperagent(
    post(`${CORDER_V1_API_PREFIX}/order/submit`, {
      sourceType: SOURCE_TYPE,
      ...data,
      deviceInfoByWeb: {
        ...getRiskParams(),
        ...(data || {}).deviceInfoByWeb,
      },
    })
  );
}

export function queryAllCampaigns(data) {
  return afterGateway(
    post(`${CORDER_V1_API_PREFIX}/search/queryAllCampaign`, {
      sourceType: SOURCE_TYPE,
      currentTimeMillis: new Date().getTime(),
      ...data,
    })
  );
}

export function queryLodgers() {
  return afterGateway(get(`${CORDER_V1_API_PREFIX}/search/queryTravelerList`));
}

export function queryCertTypes() {
  return afterGateway(get(`${CORDER_V1_API_PREFIX}/search/queryIdTypeList`)).then(obj =>
    Object.keys(obj).map(key => ({ value: Number(key), name: obj[key] }))
  );
}

export function operateLodger({ action, userList }) {
  return afterGateway(post(`${CORDER_V1_API_PREFIX}/order/opTraveler`, { action, userList }));
}

export function verifyLodgers({ userList }) {
  return afterGateway(post(`${CORDER_V1_API_PREFIX}/order/verifyTravelerList`, { userList }));
}

export function getUserVerifyInfo() {
  return afterGateway(get("/gw/corder/api/v1/search/queryUserVerifyInfo")).then(r => ({ userType: 1, ...r }));
}

// helpers
/**
 *
 * @param pricePreviewInfo
 * @returns {*}
 */
export function pricePreviewInfoToSubmitInfo(pricePreviewInfo) {
  if (!pricePreviewInfo) return {};
  return {
    orderId: pricePreviewInfo.orderId,
    checkinDate: pricePreviewInfo.checkinDate,
    checkoutDate: pricePreviewInfo.checkoutDate,
    checkinGuests: pricePreviewInfo.checkinGuests,
    discountInfos: pricePreviewInfo.discountInfos,
    ...pricePreviewInfo.priceInfo,
  };
}
